import { render, staticRenderFns } from "./flow_table.vue?vue&type=template&id=b125f5de&scoped=true&"
import script from "./flow_table.vue?vue&type=script&lang=js&"
export * from "./flow_table.vue?vue&type=script&lang=js&"
import style0 from "./flow_table.vue?vue&type=style&index=0&id=b125f5de&scoped=true&lang=css&"
import style1 from "./flow_table.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b125f5de",
  null
  
)

export default component.exports